import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "redux/store";

export const selectModal = (state: RootState) => state.modal;

export const selectModalsConfig = createSelector(
  [selectModal],
  ({ errorConfig, successConfig, summaryConfig }) => ({
    errorConfig,
    successConfig,
    summaryConfig,
  })
);
